"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTRGain = exports.ALL_TERRAFORMING_CARDS = void 0;
var CardName_1 = require("../CardName");
var constants_1 = require("../constants");
var TerraformingUnits_1 = require("../TerraformingUnits");
var TRBonus = (function () {
    function TRBonus(partialUnits) {
        this.units = TerraformingUnits_1.TerraformingUnits.of(partialUnits);
    }
    return TRBonus;
}());
exports.ALL_TERRAFORMING_CARDS = new Map([
    [CardName_1.CardName.DEEP_WELL_HEATING, new TRBonus({ temperature: 1 })],
    [CardName_1.CardName.ASTEROID, new TRBonus({ temperature: 1 })],
    [CardName_1.CardName.COMET, new TRBonus({ temperature: 1, ocean: 1 })],
    [CardName_1.CardName.BIG_ASTEROID, new TRBonus({ temperature: 2 })],
    [CardName_1.CardName.IMPORTED_HYDROGEN, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.BLACK_POLAR_DUST, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.RELEASE_OF_INERT_GASES, new TRBonus({ tr: 2 })],
    [CardName_1.CardName.NITROGEN_RICH_ASTEROID, new TRBonus({ temperature: 1, tr: 2 })],
    [CardName_1.CardName.DEIMOS_DOWN, new TRBonus({ temperature: 3 })],
    [CardName_1.CardName.DEIMOS_DOWN_PROMO, new TRBonus({ temperature: 3 })],
    [CardName_1.CardName.LAKE_MARINERIS, new TRBonus({ ocean: 2 })],
    [CardName_1.CardName.MANGROVE, new TRBonus({ oxygen: 1 })],
    [CardName_1.CardName.MINING_EXPEDITION, new TRBonus({ oxygen: 1 })],
    [CardName_1.CardName.TOWING_A_COMET, new TRBonus({ oxygen: 1, ocean: 1 })],
    [CardName_1.CardName.GIANT_ICE_ASTEROID, new TRBonus({ temperature: 2, ocean: 2 })],
    [CardName_1.CardName.NUCLEAR_ZONE, new TRBonus({ temperature: 2 })],
    [CardName_1.CardName.ARTIFICIAL_LAKE, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.SUBTERRANEAN_RESERVOIR, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.STRIP_MINE, new TRBonus({ oxygen: 2 })],
    [CardName_1.CardName.LAVA_FLOWS, new TRBonus({ temperature: 2 })],
    [CardName_1.CardName.LARGE_CONVOY, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.CONVOY_FROM_EUROPA, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.IMPORTED_NITROGEN, new TRBonus({ tr: 1 })],
    [CardName_1.CardName.MAGNETIC_FIELD_GENERATORS, new TRBonus({ tr: 3 })],
    [CardName_1.CardName.MAGNETIC_FIELD_GENERATORS_PROMO, new TRBonus({ tr: 3 })],
    [CardName_1.CardName.MAGNETIC_FIELD_DOME, new TRBonus({ tr: 1 })],
    [CardName_1.CardName.PROTECTED_VALLEY, new TRBonus({ oxygen: 1 })],
    [CardName_1.CardName.ICE_CAP_MELTING, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.FLOODING, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.PERMAFROST_EXTRACTION, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.PLANTATION, new TRBonus({ oxygen: 1 })],
    [CardName_1.CardName.RAD_CHEM_FACTORY, new TRBonus({ tr: 2 })],
    [CardName_1.CardName.BRIBED_COMMITTEE, new TRBonus({ tr: 2 })],
    [CardName_1.CardName.SMALL_ASTEROID, new TRBonus({ temperature: 1 })],
    [CardName_1.CardName.AIR_SCRAPPING_EXPEDITION, new TRBonus({ venus: 1 })],
    [CardName_1.CardName.ATMOSCOOP, new TRBonus({ temperature: 2 })],
    [CardName_1.CardName.COMET_FOR_VENUS, new TRBonus({ venus: 1 })],
    [CardName_1.CardName.GHG_IMPORT_FROM_VENUS, new TRBonus({ venus: 1 })],
    [CardName_1.CardName.GIANT_SOLAR_SHADE, new TRBonus({ venus: 3 })],
    [CardName_1.CardName.HYDROGEN_TO_VENUS, new TRBonus({ venus: 1 })],
    [CardName_1.CardName.NEUTRALIZER_FACTORY, new TRBonus({ venus: 1 })],
    [CardName_1.CardName.OMNICOURT, new TRBonus({ tr: 2 })],
    [CardName_1.CardName.ORBITAL_REFLECTORS, new TRBonus({ venus: 2 })],
    [CardName_1.CardName.SPIN_INDUCING_ASTEROID, new TRBonus({ venus: 2 })],
    [CardName_1.CardName.SULPHUR_EXPORTS, new TRBonus({ venus: 1 })],
    [CardName_1.CardName.WATER_TO_VENUS, new TRBonus({ venus: 1 })],
    [CardName_1.CardName.VENUS_SOILS, new TRBonus({ venus: 1 })],
    [CardName_1.CardName.VENUSIAN_PLANTS, new TRBonus({ venus: 1 })],
    [CardName_1.CardName.ICE_MOON_COLONY, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.JOVIAN_LANTERNS, new TRBonus({ tr: 1 })],
    [CardName_1.CardName.NITROGEN_FROM_TITAN, new TRBonus({ tr: 2 })],
    [CardName_1.CardName.PR_OFFICE, new TRBonus({ tr: 1 })],
    [CardName_1.CardName.WILDLIFE_DOME, new TRBonus({ oxygen: 1 })],
    [CardName_1.CardName.VOTE_OF_NO_CONFIDENCE, new TRBonus({ tr: 1 })],
    [CardName_1.CardName.POLITICAL_ALLIANCE, new TRBonus({ tr: 1 })],
    [CardName_1.CardName.DIVERSITY_SUPPORT, new TRBonus({ tr: 1 })],
    [CardName_1.CardName.JOVIAN_EMBASSY, new TRBonus({ tr: 1 })],
    [CardName_1.CardName.MAGNETIC_SHIELD, new TRBonus({ tr: 4 })],
    [CardName_1.CardName.MOHOLE_LAKE, new TRBonus({ temperature: 1, ocean: 1 })],
    [CardName_1.CardName.CONVERT_PLANTS, new TRBonus({ oxygen: 1 })],
    [CardName_1.CardName.CONVERT_HEAT, new TRBonus({ temperature: 1 })],
    [CardName_1.CardName.ASTEROID_STANDARD_PROJECT, new TRBonus({ temperature: 1 })],
    [CardName_1.CardName.GREENERY_STANDARD_PROJECT, new TRBonus({ oxygen: 1 })],
    [CardName_1.CardName.AQUIFER_STANDARD_PROJECT, new TRBonus({ ocean: 1 })],
    [CardName_1.CardName.AIR_SCRAPPING_STANDARD_PROJECT, new TRBonus({ venus: 1 })],
    [CardName_1.CardName.BUFFER_GAS_STANDARD_PROJECT, new TRBonus({ tr: 1 })],
]);
function calculateTRGain(player, card) {
    if (exports.ALL_TERRAFORMING_CARDS.has(card) === false) {
        return 0;
    }
    else {
        var oxygenStepsToRaise = 0;
        var tempStepsToRaise = 0;
        var oceanStepToRaise = 0;
        var venusStepsToRaise = 0;
        var directTRRAised = 0;
        var remainingOxygenSteps = (constants_1.MAX_OXYGEN_LEVEL - player.game.oxygenLevel);
        oxygenStepsToRaise += exports.ALL_TERRAFORMING_CARDS.get(card).units.oxygen;
        var oxygenStepsRaised = Math.min(remainingOxygenSteps, oxygenStepsToRaise);
        if (player.game.oxygenLevel < 8 && player.game.oxygenLevel + oxygenStepsRaised >= 8) {
            tempStepsToRaise++;
        }
        var remainingTemperatureSteps = (constants_1.MAX_TEMPERATURE - player.game.temperature) / 2;
        tempStepsToRaise += exports.ALL_TERRAFORMING_CARDS.get(card).units.temperature;
        var tempStepsRaised = Math.min(remainingTemperatureSteps, tempStepsToRaise);
        if (player.game.temperature < 0 && player.game.temperature + tempStepsRaised * 2 >= 0) {
            oceanStepToRaise++;
        }
        var remainingOceans = (constants_1.MAX_OCEAN_TILES - player.game.oceans);
        oceanStepToRaise += exports.ALL_TERRAFORMING_CARDS.get(card).units.ocean;
        var oceanStepsRaised = Math.min(remainingOceans, oceanStepToRaise);
        var remaingVenusSteps = (constants_1.MAX_VENUS_SCALE - player.game.venusScaleLevel) / 2;
        venusStepsToRaise += exports.ALL_TERRAFORMING_CARDS.get(card).units.venus;
        var venusStepsRaised = Math.min(remaingVenusSteps, venusStepsToRaise);
        if (player.game.venusScaleLevel < 16 && player.game.venusScaleLevel + venusStepsRaised * 2 >= 16) {
            directTRRAised++;
        }
        directTRRAised += exports.ALL_TERRAFORMING_CARDS.get(card).units.tr;
        return tempStepsRaised + oxygenStepsRaised + oceanStepsRaised + venusStepsRaised + directTRRAised;
    }
}
exports.calculateTRGain = calculateTRGain;
//# sourceMappingURL=TerraformingRatingAccounting.js.map